import { render, staticRenderFns } from "./event-shipping.vue?vue&type=template&id=0fa91917&scoped=true&"
import script from "./event-shipping.vue?vue&type=script&lang=ts&"
export * from "./event-shipping.vue?vue&type=script&lang=ts&"
import style0 from "./event-shipping.vue?vue&type=style&index=0&id=0fa91917&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa91917",
  null
  
)

export default component.exports